import { render, staticRenderFns } from "./SopaDeLetras.vue?vue&type=template&id=cc5208b2&"
import script from "./SopaDeLetras.vue?vue&type=script&lang=js&"
export * from "./SopaDeLetras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports